export const RegisterInventoryBookSymbol = Symbol('registerInventoryBook');
